import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.css';
import { ActionsBarLeftProps } from './container';
import { ActionsBarLeftTab } from './components/ActionsBarLeftTab';

export function ActionsBarLeft({
  sessionActiveTab,
  setSessionActiveTab,
  isLaunchPanelEnabled,
}: ActionsBarLeftProps): ReactElement {
  const { t } = useTranslation();

  if (!isLaunchPanelEnabled)
    return (
      <div className="header-panel header-panel--left">
        <div className={styles.actions}></div>
      </div>
    );

  return (
    <div className="header-panel header-panel--left">
      <div className={styles.actions}>
        <ActionsBarLeftTab
          isActiveTab={sessionActiveTab === 'topology'}
          label={t('sessions.tabs.topology.label')}
          onClick={() => setSessionActiveTab('topology')}
          ariaLabel={t('sessions.tabs.topology.ariaLabel')}
        />
        <ActionsBarLeftTab
          isActiveTab={sessionActiveTab === 'launchPanel'}
          label={t('sessions.tabs.launchPanel.label')}
          onClick={() => setSessionActiveTab('launchPanel')}
          ariaLabel={t('sessions.tabs.launchPanel.ariaLabel')}
        />
      </div>
    </div>
  );
}
